/*
// Edit an Entity
 * Created by Dr. Maximillian Dornseif 2021-09
 * Copyright (c) 2021, 2023 HUDORA GmbH
 */

import { IconButton } from '@fluentui/react/lib/Button'
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar'
import { DocumentNode } from 'graphql'
import React, { ReactElement, useCallback, useState } from 'react'

import { IEntity, TListQueryOptions } from '../../types'
import { EntityMutate } from '../components/EntityMutate'
import { MuiPanel, usePanelMui } from './usePanel'

export interface IEditPanelOptions {
  entity: IEntity
  schemaName: string // Name des Daten-Schemas, dass angezeigt wird
  editMutation?: DocumentNode
  listQuery?: DocumentNode
  listQueryOptions?: TListQueryOptions
}

/**
 * @deprecated
 */
export function useEditPanel(
  options: IEditPanelOptions
): [ICommandBarItemProps, ReactElement, ReactElement, (entity?: IEntity) => void] {
  const mutation = options.editMutation
  const [openPanel, panelProps, isPanelOpen, dismissPanel] = usePanelMui('Datensatz bearbeiten')
  const [entity, setEntity] = useState<IEntity>()

  const myOpenPanel = useCallback(
    (e?: IEntity): void => {
      if (e) {
        setEntity(e)
      }
      openPanel()
    },
    [openPanel]
  )

  if (!mutation) {
    return [null, null, null, null]
  }

  const commandBarItem: ICommandBarItemProps = {
    key: 'edit',
    text: 'Datensatz bearbeiten',
    title: 'vorhanden Datensatz bearbeiten',
    ariaLabel: 'Datensatz bearbeiten',
    iconProps: { iconName: 'Edit' },
    iconOnly: false,
    onClick: openPanel,
  }
  const mutateButton = mutation ? (
    <IconButton
      text="Datensatz bearbeiten"
      title="vorhandenn Datensatz bearbeiten"
      ariaLabel="Bearbeiten"
      iconProps={{ iconName: 'Edit' }}
      onClick={openPanel}
    />
  ) : null
  const thePanel =
    isPanelOpen && !!(options.entity || entity) ? (
      <MuiPanel {...panelProps} onDismiss={dismissPanel}>
        <div>
          <EntityMutate
            isOpen={true}
            entity={options.entity || entity}
            schemaName={options.schemaName}
            mutation={mutation}
            listQuery={options.listQuery}
            listQueryOptions={options.listQueryOptions}
          />
        </div>
      </MuiPanel>
    ) : null

  return [commandBarItem, thePanel, mutateButton, myOpenPanel]
}
